export const trainsWithProblem = [
  {
    class: '400',
    time: '08:34',
    from: 'London Waterloo',
    to: 'Portsmouth Harbour',
    status: 'Under Performing',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ]
    ],
  },
  {
    class: '377',
    time: '08:34',
    from: 'Elephant and Castle',
    to: 'Waterloo',
    status: 'Under Performing',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 60},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 90},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 60},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 60},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 60},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
    ],
  },
];

export const trainsWithoutProblem = [
  {
    class: '388',
    time: '08:34',
    from: 'Embankment',
    to: 'Piccadilly Circus',
    status: 'Normal',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 60},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 60},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 60},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 60},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
    ],
  },
  {
    class: '388',
    time: '08:34',
    from: 'Marylebone',
    to: 'Edgware Road',
    status: 'Normal',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ]
    ],
  },
  {
    class: '350',
    time: '08:34',
    from: 'Paddington',
    to: 'Warwick Avenue',
    status: 'Normal',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 60},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 60},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 60},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 60},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
    ],
  },
  {
    class: '350',
    time: '08:34',
    from: 'Oxford Circus',
    to: 'Bond Street',
    status: 'Normal',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ]
    ],
  },
  {
    class: '244',
    time: '08:34',
    from: 'Edgware',
    to: 'Burnt Oak',
    status: 'Normal',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ]
    ],
  },
  {
    class: '244',
    time: '08:34',
    from: 'Watford',
    to: 'Croxley',
    status: 'Normal',
    carriagesData: [
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 39},
        {hvac: 18, temperature: 88},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 30, temperature: 13},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 20, temperature: 48},
        {hvac: 18, temperature: 39},
        {hvac: 40, temperature: 24},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 27, temperature: 79},
        {hvac: 18, temperature: 39},
        {hvac: 34, temperature: 43},
        {hvac: 20, temperature: 48},
        {hvac: 23, temperature: 38},
      ],
      [
        {hvac: 40, temperature: 24},
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
        {hvac: 18, temperature: 39},
      ],
      [
        {hvac: 30, temperature: 13},
        {hvac: 20, temperature: 48},
        {hvac: 40, temperature: 24},
        {hvac: 18, temperature: 39},
        {hvac: 27, temperature: 79},
        {hvac: 23, temperature: 38},
        {hvac: 34, temperature: 43},
      ]
    ],
  },
];